<template>
  <b-form-group>
    <b-row>
      <b-col sm="6">
        <b-form-input class="col" :label="label" v-model="color" :disabled="isTransparent" />
      </b-col>
      <b-col sm="2">
        <b-form-checkbox v-model="isTransparent">透明</b-form-checkbox>
      </b-col>
      <b-col sm="1">
        <i
          class="color-button fa fa-paint-brush"
          v-show="normalizedColor === ''"
          :id="`color-button-${hash}`"
        ></i>
        <div
          :id="`color-demo-${hash}`"
          class="color-demo"
          :style="{ backgroundColor: color }"
          v-show="normalizedColor !== ''"
        ></div>
      </b-col>
    </b-row>

    <b-popover :target="`color-button-${hash}`" triggers="click blur">
      <swatches-picker :value="color" @input="updateColor" />
    </b-popover>
    <b-popover :target="`color-demo-${hash}`" triggers="click blur">
      <swatches-picker :value="color" @input="updateColor" />
    </b-popover>
  </b-form-group>
</template>

<script>
import { Swatches } from 'vue-color'

export default {
  name: 'ColorPicker',
  components: {
    SwatchesPicker: Swatches,
  },
  props: {
    value: {
      type: [String, null],
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      color: '',
      isTransparent: false,
      hash: '',
    }
  },
  computed: {
    normalizedColor() {
      return /^#[0-9A-F]{6}([0-9a-f]{2})?$/i.test(this.color) ? this.color : ''
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.color = val || ''
        this.isTransparent = val == null
      },
    },
    isTransparent(val) {
      if (val) {
        this.color = ''
        this.$emit('input', null)
      } else {
        this.$emit('input', this.color || '')
      }
    },
    color(val) {
      if (!this.isTransparent) {
        this.$emit('input', val)
      }
    },
  },
  mounted() {
    this.hash = Math.random().toString(36).slice(2)
    // 點擊外部關閉 popover（BootstrapVue 用法）
    document.body.addEventListener('click', () => {
      this.$root.$emit('bv::hide::popover')
    })
  },
  methods: {
    updateColor(color) {
      this.color = color.hex
    },
  },
}
</script>

<style scoped>
.color-demo {
  cursor: pointer;
  height: 32px;
  width: 32px;
  border: solid 1px;
  border-radius: 3px;
  display: inline-block;
}
.color-button {
  cursor: pointer;
}
</style>

<style>
.popover {
  max-width: 100%;
}
</style>
